(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const base = root.dataset.root || '/';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:root.dataset.currency || 'USD'}).format(cents / 100);
    const cards = $$('#productGrid .product-card');
    const catalog = new Map(cards.map(card => {
      const p = JSON.parse(card.dataset.product);
      return [String(p.id), {...p, colorSwatches:JSON.parse(card.dataset.colorSwatches || '[]'), url:card.dataset.url, image:card.querySelector('img')?.src || ''}];
    }));
    const cardPickers = new Map();
    cards.forEach(card => {
      const id = String(JSON.parse(card.dataset.product).id);
      const p = catalog.get(id);
      const hasColors = (p.options || []).some(option => /^colou?r$/i.test(typeof option === 'string' ? option : option.name));
      if (!hasColors) return;
      let colors = card.querySelector('[data-card-colors]');
      if (!colors) { colors = document.createElement('div');colors.className = 'product-color-options';card.querySelector('.product-image-wrap').insertAdjacentElement('afterend',colors); }
      cardPickers.set(id,window.initSlimieeVariants(colors,{product:p,colorOnly:true,onChange:variant => {
        if (!variant) return;
        p.selectedVariantId = variant.id;
        const photo = card.querySelector('.product-image');
        const image = variant.featured_image?.src || variant.image?.src || (typeof variant.image === 'string' ? variant.image : null) || p.image;
        if (photo && photo.src !== image) { photo.removeAttribute('srcset');photo.src = image; }
        const price = card.querySelector('.product-price');if (price) price.textContent = money(variant.price);
      }}));
    });
    let saved = [];
    try { const value = JSON.parse(localStorage.getItem('slimiee-saved-products') || '[]'); if (Array.isArray(value)) saved = value.filter(p => p && p.id && typeof p.title === 'string' && typeof p.url === 'string' && p.url.startsWith(base + 'products/')); } catch {}
    let active = null, trigger = null, toastTimer;
    const backgrounds = () => [...root.children].filter(el => !el.matches('.drawer,.mobile-menu,.quick-view,.overlay,.coupon-wheel-overlay,.toast,script'));
    function notify(message) {
      $('#toast').textContent = message;
      $('#toast').classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => $('#toast').classList.remove('show'), 3500);
    }
    function closePanel(restore = true) {
      if (!active) return;
      active.classList.remove('open');
      active.inert = true;
      if (active.id === 'couponWheelOverlay') active.hidden = true;
      $('#overlay').classList.remove('open');
      backgrounds().forEach(el => el.inert = false);
      $('#menuButton').setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      active = null;
      if (restore) {
        if (trigger?.isConnected && !trigger.closest('[inert]')) trigger.focus();
        else $('#cartToggle').focus();
      }
    }
    function openPanel(panel) {
      const previousTrigger = document.activeElement;
      closePanel(false);
      trigger = previousTrigger;
      active = panel;
      backgrounds().forEach(el => el.inert = true);
      panel.inert = false;
      panel.hidden = false;
      panel.classList.add('open');
      if (panel.id !== 'couponWheelOverlay') $('#overlay').classList.add('open');
      $('#menuButton').setAttribute('aria-expanded', String(panel.id === 'mobileMenu'));
      document.body.style.overflow = 'hidden';
      panel.querySelector('button,a,select,input')?.focus();
    }
    function updateSaved() {
      $('#savedCount').textContent = saved.length;
      $('#savedDrawerCount').textContent = `(${saved.length})`;
      $$('[data-favorite]').forEach(button => {
        const selected = saved.some(p => String(p.id) === button.dataset.favorite);
        button.classList.toggle('is-saved', selected);
        button.setAttribute('aria-pressed', String(selected));
        const title = catalog.get(button.dataset.favorite)?.title || 'this piece';
        button.setAttribute('aria-label', `${selected ? 'Unsave' : 'Save'} ${title}`);
        button.textContent = selected ? '♥' : '♡';
      });
      $('#savedItems').innerHTML = saved.length ? saved.map(p => `<div class="saved-line"><img src="${escape(p.image)}" alt=""><div><h3><a href="${escape(p.url)}">${escape(p.title)}</a></h3><p>${money(p.price)}</p><button data-unsave="${escape(p.id)}">Remove</button></div></div>`).join('') : '<div class="drawer-empty"><span>♡</span><h3>Save the ones you love</h3><p>Tap the heart on any piece to keep it close.</p></div>';
    }
    function persistSaved() {
      try { localStorage.setItem('slimiee-saved-products', JSON.stringify(saved)); } catch { notify('Saved pieces will last until this page closes.'); }
      updateSaved();
    }
    let winterFilter = 'All';
    root.querySelectorAll('[data-winter-filter]').forEach(button => button.addEventListener('click', () => {
      winterFilter = button.dataset.winterFilter;
      root.querySelectorAll('[data-winter-filter]').forEach(tab => {tab.classList.toggle('selected',tab === button);tab.setAttribute('aria-pressed',String(tab === button));});
      filter();
    }));
    function filter() {
      const query = $('#searchInput').value.trim().toLocaleLowerCase();
      const availableOnly = $('#availableOnly').checked;
      const sort = $('#sortSelect').value;
      const ordered = [...cards];
      if (sort !== 'featured') ordered.sort((a,b) => (Number(a.dataset.price) - Number(b.dataset.price)) * (sort === 'high' ? -1 : 1));
      let count = 0;
      ordered.forEach(card => {
        const p = catalog.get(String(JSON.parse(card.dataset.product).id));
        card.hidden = !(`${p.title} ${p.type || ''} ${(p.tags || []).join(' ')}`.toLocaleLowerCase().includes(query)) || (availableOnly && card.dataset.available !== 'true') || (winterFilter !== 'All' && card.dataset.winterGroup !== winterFilter);
        if (!card.hidden) count++;
        $('#productGrid').append(card);
      });
      $('#setsCount').textContent = `${count} ${count === 1 ? 'style' : 'styles'}${root.dataset.collectionPage ? ' on this page' : ''}`;
      $('#emptyState').hidden = count > 0;
    }
    async function request(path, data) {
      const response = await fetch(base + path, data ? {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(data)} : {headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Please try again.');
      return result;
    }
    async function showCart() {
      $('#cartItems').textContent = 'Loading your bag…';
      $('#drawerFoot').hidden = true;
      openPanel($('#cartDrawer'));
      try { renderCart(await request('cart.js')); } catch (error) { $('#cartItems').textContent = error.message; }
    }
    function renderCart(cart) {
      $('#cartCount').textContent = cart.item_count;
      $('#dockCartCount').textContent = cart.item_count;
      $('#drawerItemCount').textContent = `(${cart.item_count})`;
      $('#cartSubtotal').textContent = money(cart.total_price);
      $('#drawerFoot').hidden = !cart.item_count;
      $('#cartItems').innerHTML = cart.items.length ? cart.items.map(item => `<div class="cart-line">${item.image ? `<img src="${escape(item.image)}" alt="">` : ''}<div><h3><a href="${escape(item.url)}">${escape(item.product_title)}</a></h3><p>${escape(item.variant_title || '')} · Qty ${item.quantity}</p><button class="remove-line" data-remove="${escape(item.key)}">Remove</button></div><span class="cart-line-price">${money(item.final_line_price)}</span></div>`).join('') : '<div class="drawer-empty"><span>♡</span><h3>Your bag is waiting</h3><p>Find something that feels like you.</p></div>';
    }
    function quickView(id) {
      const p = catalog.get(id);
      if (!p) return;
      $('#quickViewContent').innerHTML = `<div class="quick-photo-panel"><img class="quick-image" src="${escape(p.image)}" alt="${escape(p.title)}"></div><div class="quick-details"><p class="eyebrow">${escape(p.type || 'New arrivals')}</p><h2>${escape(p.title)}</h2><div class="quick-price" id="quickPrice">${money(p.price)}</div><div id="quickVariantOptions"></div><button class="button button-dark" id="addToBag">ADD TO BAG +</button><a class="button button-outline live-product-button" href="${escape(p.url)}">VIEW FULL DETAILS ↗</a><p id="quickStatus" role="status" aria-live="polite"></p></div>`;
      const button = $('#addToBag');
      let adding = false;
      const picker = window.initSlimieeVariants($('#quickVariantOptions'), {product:p,selectedId:p.selectedVariantId,onChange:variant => {
        if (variant) cardPickers.get(id)?.setSelectedVariant(variant.id);
        button.disabled = adding || !variant?.available;
        button.textContent = !variant ? 'UNAVAILABLE' : !variant.available ? 'SOLD OUT' : 'ADD TO BAG +';
        $('#quickPrice').textContent = money(variant ? variant.price : p.price);
        $('#quickStatus').textContent = !variant ? 'This combination is unavailable. Choose another color or size.' : !variant.available ? 'This option is sold out.' : '';
        const image = variant?.featured_image?.src || variant?.image?.src || (typeof variant?.image === 'string' ? variant.image : null) || p.image;
        $('#quickViewContent .quick-image').src = image;
      }});
      const colors = $('#quickVariantOptions .color-dot-field');
      if (colors) { colors.classList.add('under-photo-colors');$('#quickViewContent .quick-photo-panel').append(colors); }
      button.addEventListener('click', async () => {
        const variant = picker.getSelectedVariant();
        if (!variant?.available || adding) return;
        adding = true;
        button.disabled = true;
        $('#quickStatus').textContent = 'Adding to your bag…';
        try {
          await request('cart/add.js', {items:[{id:Number(variant.id), quantity:1}]});
          await showCart(); notify('Added to your bag');
        } catch (error) { $('#quickStatus').textContent = error.message; }
        finally { adding = false; button.disabled = !picker.getSelectedVariant()?.available; }
      });
      openPanel($('#quickView'));
    }
    root.addEventListener('click', async event => {
      const target = event.target.closest('button,a');
      if (!target) return;
      if (target.dataset.favorite) {
        const p = catalog.get(target.dataset.favorite);
        if (saved.some(item => String(item.id) === target.dataset.favorite)) saved = saved.filter(item => String(item.id) !== target.dataset.favorite);
        else if (p) saved.push({id:p.id,title:p.title,price:p.price,image:p.image,url:p.url});
        persistSaved();
      }
      if (target.dataset.unsave) { saved = saved.filter(p => String(p.id) !== target.dataset.unsave); persistSaved(); }
      if (target.dataset.quick) quickView(target.dataset.quick);
      if (target.hasAttribute('data-close') || ['menuClose','quickClose','couponWheelClose'].includes(target.id)) closePanel();
      if (target.dataset.remove) {
        target.disabled = true;
        try { renderCart(await request('cart/change.js', {id:target.dataset.remove,quantity:0})); }
        catch (error) { notify(error.message); target.disabled = false; }
      }
      const action = target.dataset.dock;
      if (target.id === 'cartToggle' || action === 'bag') showCart();
      if (target.id === 'savedToggle' || action === 'saved') { updateSaved(); openPanel($('#savedDrawer')); }
      if (target.id === 'menuButton') openPanel($('#mobileMenu'));
      if (action === 'sets') location.href = base + 'collections/sets';
      if (action === 'shop') $('#shop').scrollIntoView({behavior:'smooth'});
    });
    $('#overlay').addEventListener('click', () => closePanel());
    document.addEventListener('keydown', event => {
      if (!active) return;
      if (event.key === 'Escape') { event.preventDefault(); closePanel(); }
      if (event.key === 'Tab') {
        const focusable = [...active.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex="0"]')].filter(el => !el.hidden && el.getClientRects().length);
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    });
    $('#searchInput').addEventListener('input', filter);
    $('#availableOnly').addEventListener('change', filter);
    $('#sortSelect').addEventListener('change', filter);
    $('#searchClose').addEventListener('click', () => { $('#searchInput').value = ''; filter(); $('#searchInput').focus(); });
    $('#searchToggle').addEventListener('click', () => { $('#searchRow').hidden = false; $('#searchInput').focus(); $('#shop').scrollIntoView({behavior:'smooth'}); });
    $('#resetFilters').addEventListener('click', () => { winterFilter = 'All'; root.querySelectorAll('[data-winter-filter]').forEach(tab => { const selected = tab.dataset.winterFilter === 'All'; tab.classList.toggle('selected', selected); tab.setAttribute('aria-pressed', String(selected)); }); $('#searchInput').value = ''; $('#availableOnly').checked = false; $('#sortSelect').value = 'featured'; filter(); });
    window.initSlimieeWheel?.(root, {open: () => openPanel($('#couponWheelOverlay')), close: () => closePanel()});
    updateSaved(); filter();
    request('cart.js').then(cart => {
      $('#cartCount').textContent = cart.item_count;
      $('#dockCartCount').textContent = cart.item_count;
    }).catch(() => {});
  }
  document.querySelectorAll('[data-slimiee-store]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-slimiee-store]').forEach(init));
})();
